module.exports = __webpack_public_path__ + "img/header-logo.db22fdd4.png";